import { GlobalStyles } from "@mui/material";

export const dashboardDensityMediaQuery =
  "@media (min-width: 1600px) and (min-height: 900px) and (max-height: 1080px) and (resolution: 1dppx)";

export const dashboardDensityClassNames = {
  dataTable: "cmp-dashboard-density-data-table",
  formField: "cmp-dashboard-density-form-field",
  manageSectionDescription: "cmp-dashboard-density-manage-description",
  manageSectionTitle: "cmp-dashboard-density-manage-title",
} as const;

export const dashboardDensityTypographyPx = {
  root: { regular: 16, dense: 15 },
  dataTable: { regular: 14, dense: 13 },
  formInput: { regular: 15, dense: 14 },
  formLabel: { regular: 14, dense: 13 },
  manageDescription: { regular: 14, dense: 13 },
  manageTitle: { regular: 18, dense: 17 },
} as const;

const importantPixels = (value: number) => `${value}px !important`;

/**
 * A deliberately narrow density pass for 1x desktop viewports close to
 * 1920x1080. Retina/HiDPI Macs, mobile/tablet widths, 125%+ browser zoom, and
 * larger desktop canvases retain the ordinary accessible type scale.
 */
export const DashboardDensityStyles = () => (
  <GlobalStyles
    styles={{
      [dashboardDensityMediaQuery]: {
        ":root": {
          // Scale rem-based Tailwind/MUI/page-owned typography and spacing by
          // one conservative step across the dashboard at 1080p/1x.
          fontSize: importantPixels(dashboardDensityTypographyPx.root.dense),
        },
        [`.${dashboardDensityClassNames.manageSectionTitle}`]: {
          fontSize: importantPixels(
            dashboardDensityTypographyPx.manageTitle.dense
          ),
        },
        [`.${dashboardDensityClassNames.manageSectionDescription}`]: {
          fontSize: importantPixels(
            dashboardDensityTypographyPx.manageDescription.dense
          ),
        },
        [`.${dashboardDensityClassNames.formField} > label`]: {
          fontSize: importantPixels(
            dashboardDensityTypographyPx.formLabel.dense
          ),
        },
        [`.${dashboardDensityClassNames.formField} .MuiInputBase-input, .${dashboardDensityClassNames.formField} [aria-haspopup="dialog"]`]:
          {
            fontSize: importantPixels(
              dashboardDensityTypographyPx.formInput.dense
            ),
          },
        [`.${dashboardDensityClassNames.dataTable} .MuiTableCell-root, .${dashboardDensityClassNames.dataTable} .MuiTableSortLabel-root, .${dashboardDensityClassNames.dataTable} .text-sm`]:
          {
            fontSize: importantPixels(
              dashboardDensityTypographyPx.dataTable.dense
            ),
          },
      },
    }}
  />
);
